module.exports = __webpack_public_path__ + "img/notification-bell-mobile-fr.fa0c417c.jpg";